import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
    ModalBody, ModalCloseButton, Text, Button, Flex } from "@chakra-ui/react";

import { useContext } from 'react';
import { CartContext } from '../CartContext';
import { useTranslation } from 'react-i18next';

const CartModal = ( props ) => {

    const { t } = useTranslation();
    const [cart, setCart] = useContext( CartContext );
    const { isOpen, onClose } = props;

    let price = 0;

    return (
        <Modal isOpen={isOpen} onClose={onClose} maxHeight="75vh" isCentered>
                <ModalOverlay />
                <ModalContent>
                <ModalHeader>
                    {t("estimateCheck")}
                    <Text fontSize="xs" fontWeight="normal" lineHeight={1}>
                        { t("cartPriceWarning") }
                    </Text>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {cart.map( (cartItem, index)=> {
                            if( cartItem.price && cartItem.amount )
                                price+= (cartItem.price*cartItem.amount);
                            
                            return (
                            <Flex alignItems="center" key={cartItem.ID}>
                                <Text fontWeight="500" fontSize="medium" width="80%"
                                    color="lightblack" 
                                    lineHeight="4" mb={1} mt={3}>
                                        { cartItem.name }
                                        <Text display="inline-block" ml={1} color="highlight" as="span">
                                            { " x" + cartItem.amount }
                                        </Text>
                                 </Text>
                                 <Text ml="auto">
                                    { (cartItem.price*cartItem.amount) + '€' }
                                 </Text>
                            </Flex>); 
                        })
                    }
                </ModalBody>

                <ModalFooter borderTop="1px solid" borderTopColor="separator" 
                            boxShadow="0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 5px -1px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)">

                    <Flex width="100%" justifyContent="space-between" alignItems="center">
                        <Text fontWeight="600" fontSize="large" color="highlight">
                             { t("priceModal") + ' ' + price + ' €' } 
                        </Text>
                        <Button alignSelf="flex-end" colorScheme="blue" mr={3} onClick={onClose} bg="primary">
                            {t("closeModal")}
                        </Button>
                        <Button alignSelf="flex-end" variant="ghost"
                                onClick={ ()=> setCart( [] ) }>{ t("emptyCart") }</Button>
                    </Flex>
                    
                </ModalFooter>
                </ModalContent>
            </Modal>
    );
}

export default CartModal;